import React from 'react';
import logo from '../../../assets/vetrho.svg';
import Typography from '../common/Typography';

interface Props {
  style?: React.CSSProperties;
}

export default function VetrhoBranding({
  style
}: Props) {
  return (
    <div
      className='flex flex-col gap-2 items-center'
      style={style}>
      <Typography variant='label' colorVariant='textLabel'>Sviluppato da</Typography>
      <img src={logo} 
        alt='Vetrho' 
        className="w-16 h-auto" />
    </div>
  )
}